<div class="cc-component-search-host" *ngIf="isSearchEnabledByMarket$ | async">
  <div class="cc-component-search-host__buttons">
    <ccwb-round-button
      class="cc-component-search-host__toggle-button"
      [theme]="isDisplaySelectablesSearch ? 'dark' : 'light'"
      [ccTrackClickOnce]="trackingData"
      (click)="toggleSelectablesSearch($event)"
      size="m"
      elevation="xs"
    >
      <ccwb-icon name="search" />
    </ccwb-round-button>
  </div>

  <cc-lazy-host
    class="cc-component-search-host__lazy-host"
    *ngIf="isInitializeSelectablesSearch"
    [componentId]="selectablesSearchComponent"
    [hidden]="!isDisplaySelectablesSearch"
  />
</div>
